export const namesinputfields = {
  users: ['name', 'email', 'password', 'password_confirmation'],
  contract_signatures: ['name', 'cpf', 'email']
}
